import { styled } from "@material-ui/core/styles";
import LocalizedLink from "../../../../components/localized-link";
import { BORDER_RADIUS, BORDER_RADIUS_MOBILE } from "../../constants";

export const BackgroundLink = styled(LocalizedLink)(({ theme }) => ({
  display: "block",
  width: "100%",
  height: "100%",
  position: "absolute",
  top: 0,
  left: 0,
  borderRadius: BORDER_RADIUS,
  [theme.breakpoints.down("xs")]: {
    borderRadius: BORDER_RADIUS_MOBILE
  }
}));
